import React, { Component } from 'react';
// import MenuToggle from './../../components/Navigation/MenuToggle/MenuToggle';
// import Drawer from '../../components/Navigation/Drawer/Drawer';
import { connect } from 'react-redux';
import Navigation from '../Navigation/Navigation';
import PageContent from '../../containers/PageContent/PageContent';

class Layout extends Component {
  render() {
    return (
      <>
        <Navigation />

        <PageContent className="content-wrapper">
          {this.props.children}
        </PageContent>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.token,
  };
}

export default connect(mapStateToProps)(Layout);
